/**
 * Shared zod row schemas for the Help Center contracts. Mirror of v22
 * SQL — keep in lockstep with packages/ui/src/types/help.ts and the
 * migration in excellent/src/projects/migrations.ts.
 */

import { z } from "zod";

export const helpIdParams = z.object({ id: z.coerce.number().int() });

export const helpCategoryRowSchema = z.object({
  id: z.number(),
  workspace_id: z.number(),
  slug: z.string(),
  name: z.string(),
  description: z.string().nullable(),
  icon: z.string().nullable(),
  sort_key: z.string(),
  archived_at: z.string().nullable(),
  created_at: z.string(),
  updated_at: z.string(),
  created_by_actor_id: z.number().nullable(),
});

export const helpArticleRowSchema = z.object({
  id: z.number(),
  workspace_id: z.number(),
  category_id: z.number(),
  slug: z.string(),
  title: z.string(),
  summary: z.string().nullable(),
  body_md: z.string(),
  source: z.enum(["seed", "user"]),
  product: z.string().nullable(),
  sort_key: z.string(),
  published: z.number(),
  locale: z.string(),
  view_count: z.number(),
  helpful_count: z.number(),
  unhelpful_count: z.number(),
  archived_at: z.string().nullable(),
  created_at: z.string(),
  updated_at: z.string(),
  created_by_actor_id: z.number().nullable(),
});

export const helpExternalLinkRowSchema = z.object({
  id: z.number(),
  workspace_id: z.number(),
  kind: z.string(),
  url: z.string(),
  label: z.string(),
  description: z.string().nullable(),
  icon: z.string().nullable(),
  enabled: z.number(),
  sort_key: z.string(),
  archived_at: z.string().nullable(),
  created_at: z.string(),
  updated_at: z.string(),
});

export const helpSearchHitSchema = z.object({
  article_id: z.number(),
  category_id: z.number(),
  category_slug: z.string(),
  category_name: z.string(),
  slug: z.string(),
  title: z.string(),
  summary: z.string().nullable(),
  snippet: z.string(),
  rank: z.number(),
});
